module.exports = __webpack_public_path__ + "img/badge_gray_fia-foundation.72188c51.svg";